import type { JSX } from 'react';
import type { WireSourceInstance } from '@logistics/contracts';
import { useInstances } from './use-sources';

export function isDemoSource(instance: WireSourceInstance): boolean {
  return instance.settings['demo'] === true;
}

/** Always on in a demo workspace, so an invented number is never taken for a real one. */
export function DemoBanner(): JSX.Element | null {
  const instances = useInstances();
  if (instances.data?.some(isDemoSource) !== true) return null;
  return (
    <div
      role="status"
      className="bg-warning-soft text-warn border-line relative border-b px-4 py-1.5 text-center text-[13px] font-medium"
    >
      Demo data: an invented fleet, not a real company.
    </div>
  );
}
